import { makeApiRequest } from 'actions/api';
import { GET_MENU_CATEGORIES_V3 } from 'lib/constants/v3Actions';
import RequestService from 'services/RequestService';

export const getMenuCategories = (menuSlug, mealPlanSlug, isEasyPrep) =>
  makeApiRequest({
    requestType: GET_MENU_CATEGORIES_V3,
    method: RequestService.v3.getMenuCategories,
    params: { menuSlug, mealPlanSlug, isEasyPrep },
  });
